function init() {
  $('.layout-applications [data-toggle="modal"]').on('click', function(e) {
    e.preventDefault();

    const href = $(this).attr('data-href');
    const queryString = href.includes('?') ? href.split('?')[1] : '';
    const urlParams = new URLSearchParams(queryString);

    // Get all query parameters
    const params = {};
    urlParams.forEach(function(value, key) {
      if (value) {
        params[key] = value;
      }
    });

    // Check checkboxes for each parameter value
    Object.values(params).forEach(value => {
      const checkbox = $(`.gfield-choice-input[value="${value}"]`);
      if (checkbox.length > 0) {
        checkbox.prop('checked', true);
        console.log(`Checked checkbox with value: ${value}`);
      } else {
        console.log(`No checkbox found with value: ${value}`);
      }
    });
  });
}

export default init;



// WEBPACK FOOTER //
// ./scripts/flexible-content/applications.js